export function floatStringSorting(rowA, rowB) {
	if (parseFloat(rowA) < parseFloat(rowB)) {
		return -1;
	}
	if (parseFloat(rowA) > parseFloat(rowB)) {
		return 1;
	}
	return 0;
}

export function percentageSorting(rowA, rowB) {
	if (parseFloat(rowA.split(" ")[0]) < parseFloat(rowB.split(" ")[0])) {
		return -1;
	}
	if (parseFloat(rowA.split(" ")[0]) > parseFloat(rowB.split(" ")[0])) {
		return 1;
	}
	return 0;
}
